var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 27,
    viewBox: "0 0 41 27",
    width: 41,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 5.1838C12.6 3.09251 14.3 1.29999 16.5 1.29999H35.8C37.9 1.29999 39.7 2.99293 39.7 5.1838V16.6361C39.7 18.7274 38 20.5199 35.8 20.5199H28.3H27.5",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6 12.9515L39.7 12.6527",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6.578H36.2",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 25.3H5.2C3.1 25.3 1.3 23.607 1.3 21.4162V9.96389C1.3 7.8726 3 6.08008 5.2 6.08008H24.5C26.6 6.08008 28.4 7.77302 28.4 9.96389V21.4162C28.4 23.607 26.6 25.3 24.5 25.3Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3 17.4328H28.4",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.8145H13.5",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 21.8145H8.3",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 11.358H24.9",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartao);
export default __webpack_public_path__ + "static/media/cartao.0277c1112417eaa7a7a3ef46234b3d01.svg";
export { ForwardRef as ReactComponent };